import _ from "lodash";
import { useContext, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import dateFormat from "dateformat";
import numeral from "numeral";
import cx from "classnames";

import { fetchDealRoomDetails } from "src/redux/actions/dealRoom";
import { DealRoomContext } from "../../context";

import SalesforceLogo from "src/legacy/images/integrations/salesforce.svg";
import HubspotLogo from "src/legacy/images/hubspotLogo.svg";
import PipedriveLogo from "src/legacy/images/pipedrive_logo.svg";
import MsDynamicsLogo from "src/legacy/images/integrations/msDynamics.png";

import styles from "./styles.module.scss";

const DealDetails = () => {
  const dispatch = useDispatch();
  const { id: dealRoomId, dealId } = useContext(DealRoomContext);

  const getIntegrationLogo = (integrationType: string) => {
    switch (integrationType) {
      case "ms_dynamics":
        return MsDynamicsLogo;
      case "ms_dynamics_v2":
        return MsDynamicsLogo;
      case "salesforce":
        return SalesforceLogo;
      case "salesforce_v2":
        return SalesforceLogo;
      case "hubspot":
        return HubspotLogo;
      case "pipedrive":
        return PipedriveLogo;
      default:
        return null;
    }
  }

  const dealRoomDetails = useSelector((state: any) => {
    const data = _.get(state, `dealRooms.dealRoom['${dealRoomId}'].dealInsights.details.data`, {});

    const formatDate = (date: any) => date ? dateFormat(date, "dd mmm yyyy") : 'N/A';

    const formatPrediction = (prediction: number) => {
      if (prediction) {
        return `${numeral(prediction).format("(0)")}%`
      } else {
        return 'N/A';
      }
    }

    return [
      { heading: _.get(data, 'title', 'N/A'), subtext: 'Opportunity' },
      { heading: _.get(data, 'value') ? `$${_.get(data, 'value')}` : 'N/A', subtext: 'Deal Value' },
      { heading: _.get(data, 'stage', 'N/A'), subtext: 'Deal Stage' },
      { heading: formatDate(_.get(data, 'createdDate')), subtext: 'Last Activity' },
      { heading: formatPrediction(_.get(data, 'prediction', null)), subtext: 'Paperflite Prediction' },
      { heading: _.get(data, 'owner', 'N/A'), subtext: 'Deal Owner' },
      { heading: _.get(data, 'remainingDays', 0), subtext: 'Days Remaining' },
      { heading: formatDate(_.get(data, 'createdDate')), subtext: 'Created Date' },
      {
        heading: _.get(data, 'integrationType', 'N/A'),
        subtext: 'Deal Platform',
        integrationLogo: getIntegrationLogo(_.get(data, 'integrationType', 'N/A')),
      }
    ];
  });
  const loading = useSelector((state: any) => {
    return _.get(state, `dealRooms.dealRoom['${dealRoomId}'].dealInsights.details.pagination.loading`, false);
  });
  const loaded = useSelector((state: any) => {
    return _.get(state, `dealRooms.dealRoom['${dealRoomId}'].dealInsights.details.pagination.loaded`, false);
  });

  useEffect(() => {
    if (!loading && !loaded) {
      dispatch(fetchDealRoomDetails({
        dealRoomId: dealRoomId ?? '',
        dealId: dealId ?? '',
      }));
    }
  }, [loading, loaded]);

  return (
    <div className={styles.container}>
      <div className={styles.gridContainer}>
        {
          loading ? (
            <p>Loading...</p>
          ) : _.size(dealRoomDetails) && _.map(dealRoomDetails, detail => {
            return (
              <div className={styles.detailContainer}>
                {
                  _.get(detail, 'integrationLogo') ? (
                    <img
                      className={styles.logo}
                      src={_.get(detail, 'integrationLogo') ?? ""}
                      alt={_.get(detail, 'heading')}
                    />
                  ) : (
                    <p className={cx(styles.heading, styles.truncatedText)}>
                      {_.get(detail, 'heading', 'N/A')}
                    </p>
                  )
                }
                <p className={cx(styles.subtext, styles.truncatedText)}>
                  {_.get(detail, 'subtext')}
                </p>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default DealDetails;